import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { LANDING } from "@/constants/testIds/landing";
import { useSiteContent } from "@/lib/siteContent";

export const Header = () => {
  const { content } = useSiteContent();
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#EAEAEA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid={LANDING.headerLogo}
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-2xl bg-[#6B8E23] text-white group-hover:bg-[#55711C] transition-colors">
            <Sprout size={20} strokeWidth={2.2} />
          </span>
          <span className="font-[Outfit] font-bold text-xl tracking-tight text-[#1A1A1A]">
            Waskowi
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#444]">
          <a
            href="#features"
            onClick={scrollTo("features")}
            data-testid={LANDING.navFeatures}
            className="hover:text-[#6B8E23] transition-colors"
          >
            Funktionen
          </a>
          <a
            href="#perks"
            onClick={scrollTo("perks")}
            data-testid={LANDING.navHowItWorks}
            className="hover:text-[#6B8E23] transition-colors"
          >
            Vorteile
          </a>
        </nav>

        <a
          href={content.download_link || "#"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={LANDING.navCtaButton}
          className="rounded-full px-5 py-2 text-sm font-semibold bg-[#1A1A1A] text-white hover:bg-[#6B8E23] transition-all duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-md"
        >
          Herunterladen
        </a>
      </div>
    </header>
  );
};

export default Header;

